import {BaseStore, globalStore} from "../../stem-core/state/Store";  // For order
import {field} from "../../stem-core/state/StoreField";
import {apiClient, type MerchantConversionRequest} from "../connection/BlinkApiClient";
import type {StoreId} from "../../stem-core/state/State";
import {TopUpStatus} from "./TopUpPaymentStore";
import {MoneyObject} from "../../stem-core/localization/Money";
import {MerchantConversion} from "./merchant/MerchantConversionStore";
import {StemDate} from "../../stem-core/time/Date";
import {Merchant} from "./MerchantStore";
import {MerchantUser} from "./merchant/MerchantUserStore";
import {Payment} from "./PaymentStore";

@globalStore
export class Purchase extends BaseStore("Purchase", {dependencies: ["MerchantConversion"]}, MoneyObject) {
    @field(Date) createdAt: StemDate;
    @field(Date) finalizedAt: StemDate;
    @field(TopUpStatus) status: TopUpStatus;
    @field("Merchant") merchant: Merchant;
    @field(Number) userId: number;
    @field("MerchantUser") merchantUser: MerchantUser;
    @field("MerchantConversion") conversion: MerchantConversion;
    @field("Payment") payment: Payment;
    @field(String) url: string;
    declare title: string;

    getTitle(): string {
        return this.title || `Order ${this.id}`;
    }

    isRefundable(): boolean {
        return this.payment?.isAutomatic;
    }
}

// CheckoutSummary / ProductCheckoutEntry (api/payments/models/purchase.py)
export interface ProductCheckoutEntry {
    productId: StoreId;
    quantity?: number;
    subproductId?: string;
}

// PurchaseProductRequest. merchantId is required here, unlike on the shared base
export interface PurchaseProductRequest extends MerchantConversionRequest {
    merchantId: StoreId;
    products: {entries: ProductCheckoutEntry[]};
    amount: number;
    currencyId: StoreId;
    // Both default server-side, to "maybe" and false
    useWalletFunds?: "yes" | "no" | "maybe";
    isAutomatic?: boolean;
    paymentMethodId?: StoreId;
    deliveryAddressId?: StoreId;
    title?: string;
    url?: string;
}

export async function apiUserPurchaseProduct(request: PurchaseProductRequest): Promise<Purchase> {
    const response = await apiClient.post("/payments/purchase_product", request);
    return Purchase.loadObject(response);
}

// PurchaseRefundRequest, which is not merchant-scoped
export interface PurchaseRefundRequest {
    purchaseId: StoreId;
    refundReason: string;
}

export async function apiUserRequestPurchaseRefund(request: PurchaseRefundRequest): Promise<any> {
    return apiClient.post("/payments/request_refund", request);
}
